module.exports = __webpack_public_path__ + "7772a9cd477b0b896967c784de6e409e.svg";